import { render, staticRenderFns } from "./SchoolArticleDetail.vue?vue&type=template&id=221253ec&scoped=true&"
import script from "./SchoolArticleDetail.vue?vue&type=script&lang=js&"
export * from "./SchoolArticleDetail.vue?vue&type=script&lang=js&"
import style0 from "./SchoolArticleDetail.vue?vue&type=style&index=0&id=221253ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221253ec",
  null
  
)

export default component.exports